<template>
  <section>
    <framed-image :navigate-to="skuImage" :images="productImages" />
    <div class="mx-2">
      <h2>How many would you like?</h2>
      <div class="buttons flex-wrap">
        <standard-button 
          v-for="item in filteredProducts" :key="item.sku"
          @click="setSku(item.sku)"
          :active="value == item.sku"
        >
          {{item.slots}} <em class="lowercase">for</em>
          {{item.amount | tightCurrency }}
        </standard-button>
      </div>
    </div>
  </section>
</template>


<script>
import FramedImage from './FramedImage'
import StandardButton from './StandardButton'
import { filter, map, findIndex } from 'lodash'
export default {
  model: {
    value: 'value',
    event: 'input'
  },
  props: {
    value: {},
    group: {},
  },
  components: {
    FramedImage,
    StandardButton
  },
  methods: {
    setSku(id) {
      this.$emit('input',id)
      // this.$scrollTo(document.getElementById('flavours'), 1000, { offset: -50 })
    }
  },
  computed: {
    filteredProducts() {
      return filter(this.$root.$data.products, {group: this.group})
    },
    productImages() {
      return map(this.filteredProducts, 'image')
    },
    skuImage() {
      return findIndex(this.filteredProducts, {sku: this.value})
    },
  }
}
</script>
